import { render, staticRenderFns } from "./CalculatorIrg.vue?vue&type=template&id=61953d30&scoped=true&"
import script from "./CalculatorIrg.vue?vue&type=script&lang=js&"
export * from "./CalculatorIrg.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61953d30",
  null
  
)

export default component.exports